import { ValueObject } from '../../../core/valueObject';
import type { IObjectViewModel } from '../../interfaces';

interface Props<M = unknown, VM extends IObjectViewModel = IObjectViewModel> {
  model: M;
  viewModel: VM;
}

export class ModelsPair<M = unknown, VM extends IObjectViewModel = IObjectViewModel> extends ValueObject<Props<M, VM>> {
  public constructor(model: M, viewModel: VM) {
    super({
      model,
      viewModel
    });
  }

  public get model(): M {
    return this.props.model;
  }

  public get viewModel(): VM {
    return this.props.viewModel;
  }
}
